import React from "react";

const Switch = ({ label, option, checked, onChange, disabled }) => {
    return (
        <div className="flex block text-sm font-bold text-black flex-col">

            {label && <span className="mb-2">{label}</span>}

            <label className="inline-flex items-center cursor-pointer w-fit">
                <input
                    type="checkbox"
                    className="custom-switch-input hidden"
                    checked={checked}
                    disabled={disabled}
                    onChange={(e) => onChange(e.target.checked)}
                />
                <div className="custom-switch">
                    <div className="custom-switch-thumb"></div>
                </div>
            </label>

            {option && <span className="text-black mt-1">{option}</span>}
        </div>
    );
};

export default Switch;
